const _version = "3.0.7"
function version() {
    return _version
}
export default version
